/**
 * Initial state for container visibility
 */
export const INITIAL_VISIBLE_CONTAINERS = {
  activePrograms: true,
  latestFeedback: true,
  programRequests: false,
  latestPatients: true,
  latestOwnExercises: true,
  latestCommunityExercises: true,
  pendingReviews: true
};

/**
 * Initial state for container expansion
 */
export const INITIAL_EXPANDED_CONTAINERS = {
  activePrograms: true,
  latestFeedback: true,
  programRequests: true,
  latestPatients: true,
  latestOwnExercises: true,
  latestCommunityExercises: true,
  pendingReviews: true
};

/**
 * Initial state for dashboard data
 */
export const INITIAL_DASHBOARD_DATA = {
  activePrograms: [],
  latestFeedback: [],
  programRequests: [],
  latestPatients: [],
  latestOwnExercises: [],
  latestCommunityExercises: [],
  pendingReviews: []
};

/**
 * Map language codes to locale strings for date formatting
 */
export const LOCALE_MAP = {
  'de': 'de-DE',
  'en': 'en-US',
  'it': 'it-IT'
};

/**
 * Default locale fallback
 */
export const DEFAULT_LOCALE = 'de-DE';

